import forgotPassword from 'src/screens/forgot-password';
export default forgotPassword;
